<template>
  <div class="share-link-button">
    <v-chip class="ma-auto" @click="showShareLink = !showShareLink" outlined>
      <v-icon left small>fa-regular fa-share-nodes</v-icon> Share simulation
    </v-chip>
    <ShareLink
      v-if="showShareLink"
      :fundingChallengeTestId="fundingChallengeTestId"
      @closeWindow="showShareLink = false"
    />
  </div>
</template>

<script>
import ShareLink from "@/views/Funding/Simulation/components/ShareLinkTest.vue";

export default {
  name: "ShareLinkButton",
  components: {
    ShareLink,
  },
  props: {
    fundingChallengeTestId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showShareLink: false,
    };
  },
};
</script>
<style scoped lang="scss">
.share-link-button{
  @media (max-width:720px) {
    .custom-button{
      border-radius: 50%;
      width: 36px;
      height: 36px;
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      span{
        display: none;
      } 
    }
  }
}
.custom-button {
  background-color: transparent;
  border: 1px solid var(--v-mainGreen-base);
  color: var(--v-mainGreen-base);
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 30px;
  transition: background-color 0.3s, color 0.3s;
  .v-icon {
    color: var(--v-mainGreen-base);
  }
}

.custom-button:hover {
  background-color: var(--v-mainGreen-base);
  color: white;
}
</style>
